/* The server's clock as this browser sees it: the `Date` header of a response says what time the
   server thinks it is, so a PC with a wrong clock still compares times with server times right. */

import { createStore } from "zustand/vanilla";

const offset = createStore(() => 0);
/** A slower answer says little: its `Date` may come from anywhere in the wait. */
const MAX_TRIP_MS = 2_000;

/** Notes the server's time from a response's `Date` header (second resolution, so half a second is
 * added) against the moment the request was sent and answered. */
export function noteServerDate(header: string | null, sentAt: number, receivedAt: number): void {
  if (!header || receivedAt - sentAt > MAX_TRIP_MS) return;
  const server = new Date(header).getTime();
  if (Number.isNaN(server)) return;
  const next = server + 500 - (sentAt + receivedAt) / 2;
  if (Math.abs(next - offset.getState()) < 1_000) return;
  offset.setState(next);
}

/** The server's time now, in milliseconds. */
export function serverNow(): number {
  return Date.now() + offset.getState();
}

/** Hears the offset change. */
export function onServerClock(listener: () => void): () => void {
  return offset.subscribe(() => listener());
}
